export const OPENMODALRESPONSEAPI = "OPENMODALRESPONSEAPI";
export const OPENMODALRESPONSEAPISAGA = "OPENMODALRESPONSEAPISAGA";

export const CLOSEMODALRESPONSEAPI = "CLOSEMODALRESPONSEAPI";
export const CLOSEMODALRESPONSEAPISAGA = "CLOSEMODALRESPONSEAPISAGA";
